import {
    BannersEditMassActions,
    CLOSE_MASS_ACTIONS_BANNERS_PRICE,
    ON_ACCEPT_MASS_ACTIONS_BANNERS_PRICE,
    OPEN_MASS_ACTIONS_BANNERS_PRICE
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import { BannersEditMassActionsState } from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsInitialState } from './banners-edit-mass-actions';

export function bannersEditMassActionsPriceReducer(
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: BannersEditMassActions,
    fullState: State
): BannersEditMassActionsState {
    switch (action.type) {
        case CLOSE_MASS_ACTIONS_BANNERS_PRICE:
        case ON_ACCEPT_MASS_ACTIONS_BANNERS_PRICE:
            return bannersEditMassActionsInitialState;
        case OPEN_MASS_ACTIONS_BANNERS_PRICE:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        bannerPricesEditorVisible: true
                    }
                }
            };
        default:
            return state;
    }
}
